import { useEffect, useState } from "react";
import api from "../services/api";

const layoutCache = {};

const layoutDefault = {
   logoUrl: "/images/logo_dourado.png",
  titulo: "Lion of Code",
  corPrimaria: "#1F2937",
  corSecundaria: "#374151",
};

export function usePublicLayout(entidadeId) {
  const [layout, setLayout] = useState(null);

  useEffect(() => {
    const fetchLayout = async () => {
      // ⚠️ Se não tem entidade → usa layout padrão direto
      if (!entidadeId) {
        console.warn("⚠️ Nenhum entidadeId informado. Usando layout padrão.");
        setLayout(layoutDefault);
        return;
      }

      // ✅ Cache
      if (layoutCache[entidadeId]) {
        setLayout(layoutCache[entidadeId]);
        return;
      }

      try {
        const response = await api.get(`/api/publico/layout?id=${entidadeId}`);
        const layoutData = response.data;

        layoutCache[entidadeId] = layoutData;
        setLayout(layoutData);
      } catch (error) {
        console.error("❌ Erro ao carregar layout da entidade. Usando padrão:", error);
        setLayout(layoutDefault); // fallback seguro
      }
    };

    fetchLayout();
  }, [entidadeId]);

  return layout;
}
